import * as React from 'react';
import { mergeStyles } from '@cian/utils';

import { IGetVillageListRequestSchema } from '../../../node/repositories/countryside-search/entities/schemas/GetVillageListRequestSchema';
import { generateQueryString } from '../../utils/filters';
import { scrollToTop } from '../../utils/scrollToTop';
import { getStartPage, getEndPage, getPageList } from '../../utils/paginationHelpers';

import * as styles from './Pagination.css';

export interface IPaginationProps {
  totalPages: number;
  filters: IGetVillageListRequestSchema;
  onSelect(p: number): void;
}

export class Pagination extends React.Component<IPaginationProps> {
  public render() {
    const { filters, totalPages } = this.props;
    const p = filters.p || 1;

    if (totalPages < 2 || p > totalPages) {
      return null;
    }

    return (
      <div className={styles['container']}>
        <ul className={styles['list']}>{this.renderPages()}</ul>
      </div>
    );
  }

  private renderPages() {
    const { filters, totalPages } = this.props;
    const p = filters.p || 1;

    const startPage = getStartPage(p, totalPages);
    const endPage = getEndPage(p, totalPages);
    const pagesList = getPageList(p, totalPages);

    return pagesList.map((pageNumber, index) => {
      let text = String(pageNumber);

      if (index === 1 && startPage > 2) {
        text = '...';
      }

      if (index === pagesList.length - 1 && endPage < totalPages) {
        text = '...';
      }

      return (
        <li
          key={`page-${pageNumber}`}
          {...mergeStyles(styles['list-item'], pageNumber === p && styles['list-item--active'])}
        >
          {this.renderPageLink(pageNumber, text)}
        </li>
      );
    });
  }

  private renderPageLink(pageNumber: number, text: string) {
    const { filters } = this.props;
    if (pageNumber === filters.p) {
      return <span>{pageNumber}</span>;
    }

    const pageUrl = generateQueryString({ ...filters, p: pageNumber });

    return (
      <a href={pageUrl} className={styles['list-item_link']} onClick={event => this.onClickPage(event, pageNumber)}>
        {text}
      </a>
    );
  }

  private onClickPage(event: React.MouseEvent<HTMLAnchorElement>, pageNumber: number) {
    event.preventDefault();

    scrollToTop(300);
    this.props.onSelect(pageNumber);
  }
}
